import { buildScoreDataVariables } from 'src/apps/dashboard/services/queries/score/helpers/buildVariables';
import {
	ScoreDataResult,
	transformScoreDataResults
} from 'src/apps/dashboard/services/queries/score/helpers/transformResults';
import { ScoreDataQuery } from 'src/apps/dashboard/services/queries/score/ScoreData.generated';
import { ScoreData as ScoreDataQueryDocument } from 'src/apps/dashboard/services/queries/score/ScoreData.gql';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

export const getScoreData = async (
	filters?: IFilterOptions,
	dateFrom?: string,
	dateTo?: string,
	timeframeDays?: number
): Promise<ScoreDataResult> => {
	try {
		const variables = buildScoreDataVariables(filters, dateFrom, dateTo, timeframeDays);

		const result = await gqlClient.request<ScoreDataQuery>(ScoreDataQueryDocument, variables);

		const transformedResult = transformScoreDataResults(result);
		return transformedResult;
	} catch (e) {
		Logger.error('ScoreService -> getScoreData failed with an error:', e);
		throw e;
	}
};
